import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPipingListGroups } from '../../../api/piping-list-groups';

export const getPipingListGroupsAsync = createAsyncThunk(
  'pipingListGroups/getPipingListGroups',
  getPipingListGroups
);

export interface PipingList {
  id: number;
  name: string;
  description: string | null;
}

export interface PipingListGroup {
  id: number;
  name: string;
  order: number | null;
  pipingLists: PipingList[];
}

interface PipingListGroupState {
  data: PipingListGroup[];
}

const initialState: PipingListGroupState = {
  data: []
};

export default createSlice({
  name: 'pipingListGroups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPipingListGroupsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
